import { cx } from '@emotion/css';
import { Title } from './Title';
import { HTMLAttributes } from 'react';

export const Section = (props: {
  title: string;
  className?: HTMLAttributes<HTMLDivElement>['className'];
  children: React.ReactNode;
  extra?: React.ReactNode;
}) => {
  const { title, children, extra, className } = props;
  return (
    <div className={cx('flex-grow-0 flex-shrink-0 flex flex-col overflow-hidden', className)}>
      <Title extra={extra}>{title}</Title>
      <div className="overflow-y-auto px-4">{children}</div>
    </div>
  );
};
